/*********************************YEISON INTEGRATION*/
const fileServer             = require ('./file-server-generator')
const fileServerTrash        = require ('./file-server-getDeletedFile')

/*********************************YEISON INTEGRATION*/
export function printFile( detail, result, htmlFc ){  //console.log('printFile>>>>>')
    //alert(333)  

    //checking for user entity to print profile pic
    if(htmlFc.entity == "users" || htmlFc.entity == "company" || htmlFc.entity == "nurses"  || htmlFc.entity == "patients" || 
       htmlFc.entity == "customer" || htmlFc.entity == "investor" || htmlFc.entity == "provider" || htmlFc.entity == "item" ||
       htmlFc.entity == "accounts"){  
        

        if(result.data[0].avatar == ""){
            var avatar = "person";
            if(result.data[0].hasOwnProperty('sex')){
                if(result.data[0].sex != ""){
                    avatar = result.data[0].sex.toLowerCase();
                }                
            }

            let avatarLetter      = result.data[0].avatarLetter;
            let avatarColor       = result.data[0].avatarColor;
            let avatarColorLetter = result.data[0].avatarColorLetter;

            const avatarBox   = htmlFc.fullcontHTML.querySelector(".avatar-box");
            const avatarLabel = htmlFc.fullcontHTML.querySelector(".avatar-letter");

            if(avatarBox != null && avatarLabel != null){
                if(avatarLetter != ''){
                    avatarLabel.innerHTML = avatarLetter;
    
                    avatarBox.style.cssText = `
                    background-color: #${avatarColor};
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    `;
    
                    avatarLabel.style.cssText = `
                    color: #${avatarColorLetter};
                    font-size: 30px;
                    font-weight: 400;
                    `;
                }
            }

        }

        const avatarUrl = result.data[0].avatar || 'css/img/pic/'+avatar+'.svg';
        const fcUserPic = htmlFc.fullcontHTML.querySelector(".avatar");    


        fcUserPic.style.backgroundImage = "url('')"; 
        fcUserPic.style.backgroundImage = "url('"+avatarUrl+"?" + new Date().getTime();+"'), #E6E6E6 "; 
     }



    const filePage = htmlFc.fullcontHTML.querySelector(".filePage")

    if (filePage === null) {  
        //console.log('printFile returned')
        return 
    }

     //console.log('printFile continue')  



    const  printFileObj = { 
              entity:       htmlFc.entity, 
               id:          result.data[0].id, 
               file:        result.file, 
               currentPath: "",
               form:        htmlFc.fullcontHTML
     };
    
    fileServer.printFile(printFileObj);//YEISON U

    const trash          = htmlFc.fullcontHTML.querySelector(".filePage")
    const trashIsVisible = trash.classList.contains("filePage-view-trash")


     //IF TRASH IS VISIBLE
    if (trashIsVisible) {//IF TRASH IS VISIBLE
        const posiblesIds = [
            detail.entity + "-fullcont",
            detail.entity + "-fullcont2",
            detail.entity + "-fullcont3"
        ];
        const idEntity = posiblesIds.find(id => document.querySelector("#" + id));
        if (!idEntity) {
            console.error("No se encontró ningún contenedor válido para: ", detail.entity);
            return;
        }
        document.querySelector("#" + idEntity).dataset.dbid = result.data[0].id;
        fileServerTrash.start(detail);
    
    }
          
}/*printFiles*/